/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:35:03 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-25 20:11:18
 */


import _ from 'lodash';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Systems } from '../models/system.model';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { PlatformService } from './platform.service';
import { AlertService } from './alert.service';
import { versionCompare } from '../common/utils';
import { AppVersion } from '@ionic-native/app-version';
import { AlertController } from 'ionic-angular';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class SystemService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/system`;

  private _systems: BehaviorSubject<Systems> = new BehaviorSubject(null);

  private thisVersion: string;


  constructor(
    private transService: TransService,
    private appVersion: AppVersion,
    private alertSerivce: AlertService,
    private platformService: PlatformService,
    private alertCtrl: AlertController,
    private iab: InAppBrowser,
    private http: HttpClient) {

  }

  //
  // Rest APIs
  getSystems() {
    return this.http.get(this.url);
  }

  updateSystems(values: any) {
    return this.http.put(`${this.url}?lang=${this.transService.lang}`, values);
  }


  fetchSystems() {
    this.getVersionNumber()
      .then((s: string) => {
        this.thisVersion = s;

        this.getSystems()
          .subscribe(res => {
            const payload = res['payload'];
            const systems = {} as Systems;
            _.forEach(payload, v => {
              if (_.includes('androidDownloadUrl androidVersion iosDownloadUrl iosVersion todayDay', v.key)) {
                systems[v.key] = v.value;
              }
            });
            this.updatedSystems(systems);
          });

      });
  }

  updatedSystems(values) {
    this._systems.next({
      ...values
    });
    if (!this.platformService.isWeb())
      this.checkVersion();
  }

  get systems$() {
    return this._systems.asObservable();
  }

  getVersionNumber() {
    if (this.platformService.isWeb()) {
      return new Promise(resolve => {
        resolve(ENV.WEB_VERSION);
      });

    } else {
      return this.appVersion.getVersionNumber();
    }
  }

  getValue(key: string) {
    return this._systems.value[key] || '';
  }


  pay(stripetoken, amount) {
    return this.http.post(`${this.url}/pay?lang=${this.transService.lang}`, {
      stripetoken,
      amount
    });
  }
  
  private goUpdate() {
    if (this.platformService.isAndroidApp()) {
      this.iab.create(this._systems.value.androidDownloadUrl, '_system');
    } else if (this.platformService.isIOSApp()) {
      this.iab.create(this._systems.value.iosDownloadUrl, '_system');
    } else {
      this.alertSerivce.showToastMessage('웹에서는 지원하지 않습니다.');
    }
  }


  private checkVersion() {
    let thatVersion = '';
    if (this.platformService.isAndroidApp()) {
      thatVersion = this._systems.value.androidVersion;
    } else if (this.platformService.isIOSApp()) {
      thatVersion = this._systems.value.iosVersion;
    }
    if (versionCompare(this.thisVersion, thatVersion, false) < 0) {
      const alert = this.alertCtrl.create({
        title: '업데이트',
        message: '앱 업데이트가 반드시 필요합니다.',
        enableBackdropDismiss: false,
        buttons: [{
          text: '업데이트',
          handler: () => {
            this.goUpdate();
          }
        }],
        // cssClass: 'alert'
      });
      alert.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/system.service.ts